import { render, staticRenderFns } from "./OrdersTab.vue?vue&type=template&id=f7a4f702&scoped=true"
import script from "./OrdersTab.vue?vue&type=script&lang=js"
export * from "./OrdersTab.vue?vue&type=script&lang=js"
import style0 from "./OrdersTab.vue?vue&type=style&index=0&id=f7a4f702&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a4f702",
  null
  
)

export default component.exports